import React from "react";
import "./assignAccessUser.scss";
import Button from "components/Button/index";
// import AddTeams from "./AddTeams/AddTeams";
import CreateTeamRoles from "containers/Homepage/OrganizationSetting/ManageTeam/Team/TeamAssignAccess/CreateTeamRoles/index";
import CreateTeams from "containers/Homepage/OrganizationSetting/ManageTeam/Team/TeamAssignAccess/CreateTeams/index";
// import AddRole from "./AddRole/AddRole";

function AssignAccessUser({
  updateRoles,
  updateTeams,
  roleData,
  onSubmit,
  handleCancel,
  editModal,
  handleUpdatedata
}) {
  const isButtonDisabled =
    false;

  return (
    <div className="assignAccessUserContainer">
      <div className="AssignAccessWrapper">
        {/* <AddRole updateRoles={updateRoles} initialRoles={roleData.roles} />  */}
        <CreateTeamRoles
          updateOperations={updateRoles}
          initialOperations={roleData.roles}
        />
        {/* <AddTeams updateTeams={updateTeams} initialTeams={roleData.teams} /> */}
         <CreateTeams
          updateOperations={updateTeams}
          initialOperations={roleData.teams}
        />
        {/* <CreateTeamRoles
          updateOperations={updateTeams}
          initialOperations={roleData.teams}
        /> */}
      </div>
      <div className="AssignAccessButtons">
        <Button
          type="violet"
          title={editModal ? "Update" : "Add "}
          width="250px"
          disabled={isButtonDisabled}
          onClick={() => {
            

            // onSubmit({
            //   name: roleData.name,
            //   email: roleData.email,
            //   roles: roleData.roles.map((role) => role.role),
            //   teams: roleData.teams.map((team) => team.team)
            // });
            if (editModal) {
              handleUpdatedata(roleData);
            } else {
              onSubmit(roleData);
            }
            handleCancel();
          }}
        />
      </div>
    </div>
  );
}

export default AssignAccessUser;
